import { graphql } from "react-relay";

export const UpdateOwnerProfileMutation = graphql`
  mutation UpdateOwnerProfileMutation(
    $resourceOwnerProfileInput: ResourceOwnerConfigurationInput!
    $accountOwnerProfileInput: AccountOwnersConfigurationInput!
  ) {
    addAccountOwnersProfile(input: $accountOwnerProfileInput) {
      configuration {
        profile
        record {
          ... on AccountOwnersConfiguration {
            default {
              owners
            }
            tags
          }
        }
      }
    }
    addResourceOwnerProfile(input: $resourceOwnerProfileInput) {
      configuration {
        profile
        record {
          ... on ResourceOwnerConfiguration {
            default
            tags
          }
        }
      }
    }
  }
`;
